import React from 'react'
import { Extents } from 'types/Extents'
import { Municipality } from 'types/Municipality'
import { GeojsonFeature } from 'types/GeojsonFeature'
import { feature } from 'topojson-client'
import topology from 'lib/geodata/switzerland.json'
import { colorGenerator } from 'lib/colours'

interface MapProps {
  currentExtents: Extents
  gemeinden: Map<string, Municipality>
  mapId: string
  pathGenerator: (feature: GeojsonFeature) => string
}

/**
 * Draw a choropleth map
 */
export const ChoroplethMap = ({
  currentExtents,
  gemeinden,
  mapId = '',
  pathGenerator
}: MapProps) => {
  if (!gemeinden || gemeinden.size <= 0 || !currentExtents) {
    return null
  }

  // Get an indexed version of the municipalities, so we can find the values
  // for each
  const indexedMunicipalities = gemeinden

  const gemeindeFeatures: GeojsonFeature[] = feature(
    topology,
    topology.objects.gemeinden
  ).features

  function drawSwissMunicipalities(
    colorGenerator: (value: number) => string,
    areas: GeojsonFeature[],
    areaIdProperty = 'Primary_ID',
    idGenerator = (property: string) => property
  ) {
    return areas.map((feature: GeojsonFeature, index: number) => {
      const municipalityId = idGenerator(feature.properties[areaIdProperty])
      const municipalityData = indexedMunicipalities.get(municipalityId)

      if (!municipalityData) {
        console.log(`[ChoroplethMap]: Data for ID ${municipalityId} not found.`)
        return null
      }

      const range = currentExtents[1] - currentExtents[0]

      let generatedColor: string = colorGenerator(
        (municipalityData.Belastung - currentExtents[0]) / range
      )

      return (
        <path
          key={municipalityId}
          d={pathGenerator(feature)}
          strokeWidth={0}
          vectorEffect='non-scaling-stroke'
          stroke={generatedColor}
          fill={generatedColor}
          id={`${mapId}-gemeinde-${municipalityId}`}
          className='gemeinde'
        />
      )
    })
  }

  const municipalityPaths = drawSwissMunicipalities(
    colorGenerator,
    gemeindeFeatures
  )

  return (
    <g className='all municipalities non-interactive'>{municipalityPaths}</g>
  )
}
